export enum BrandType {
  Timetailor = 'timetailor',
  Debranded = 'debranded',
}

export interface BrandConfig {
  name: string;
  type: BrandType;
  domain: string;
}
